<div class="card-box clearfix">
    <div class="row col-lg-12">
        <div class="m-b-5">{{{pagination}}}</div>
        <table class="table table-condensed js-alarm-occurence-table tablesaw tablesaw-swipe tablesaw-sortable">
            <thead>
                <tr>
                    <th>&nbsp;<input class="js-alarm-select-all" type="checkbox"></input></th>
                    {{#if alarm_name_visible}}{{#ALARMCOL "alarm_name"}}{{TR "Alarm"}}{{/ALARMCOL}}{{/if}}
                    {{#if device_name_visible}}{{#ALARMCOL "device_name"}}{{TR "Gerät"}}{{/ALARMCOL}}{{/if}}
                    {{#ALARMCOL "cond_text"}}{{TR "Bedingungen"}}{{/ALARMCOL}}
                    {{#ALARMCOL "triggered_time"}}{{TR "Zeit"}}{{/ALARMCOL}}
                    {{#ALARMCOL "corrected_time"}}{{TR "Behoben"}}{{/ALARMCOL}}
                    {{#if priority_text_visible}}{{#ALARMCOL "priority"}}{{TR "Priorität"}}{{/ALARMCOL}}{{/if}}
                    {{#ALARMCOL "is_acknowledged"}}&nbsp;{{/ALARMCOL}}
                </tr>
            </thead>
            <tbody>
                {{#each items}}
                <tr class="js-alarm-item{{#if is_acknowledged}}{{else}} active{{/if}}>">
                    <td>
                        <input data-occurence-idx="{{@index}}" class="js-alarm-select" type="checkbox" {{#if selected}}checked="checked"{{/if}}></input>
                        {{#if is_triggered}}
                        <i class="fa fa-exclamation-triangle error" title="{{TR "Alarm dauert an"}}"></i>
                        {{else}}
                        <i class="fa fa-exclamation-triangle" title="{{TR "Alarm wurde behoben"}}"></i>
                        {{/if}}

                        {{#if is_email}}
                            <i class="fa fa-envelope-o" title="{{TR "Eine E-Mail-Benachrichtigung wurde verschickt."}}"></i>
                        {{/if}}
                        {{#if is_sms}}
                            <i class="fa fa-comment" title="{{TR "Eine SMS-Benachrichtigung wurde verschickt."}}"></i>
                        {{/if}}
                    </td>
                    {{#if ../alarm_name_visible}}<td>{{#if link}}<a class="m-r-10" href="{{link}}"><i class="fa fa-bar-chart-o" title="{{TR "In Analyse zeigen"}}"></i></a>{{/if}}{{alarm_name}}</td>{{/if}}
                    {{#if ../device_name_visible}}<td>{{{DEVICE_STATUS device_status}}}
                        {{#if can_see_device}}<a href="{{device_link}}">{{/if}}
                        {{device_name}}
                        {{#if can_see_device}}</a>{{/if}}
                        </td>{{/if}}
                    <td>{{{cond_text}}}</td>
                    <td>{{TIME triggered_time}}</td>
                    <td>{{#if is_active}}{{TIMEEX corrected_time}}{{else}}{{#COMPARE corrected_time '>=' triggered_time}}{{TIMEEX corrected_time}}{{else}}{{TR "abgebrochen"}}{{/COMPARE}}{{/if}}</td>
                    {{#if ../priority_text_visible}}<td>{{priority}}</td>{{/if}}
                    {{#if is_acknowledged}}
                    <td>&nbsp;
                    </td>
                    {{else}}
                    <td>
                        <button class="btn btn-sm btn-white pull-right js-alarm-acknowledge">
                            <i class="fa fa-bell"></i>
                        </button>
                    </td>
                    {{/if}}
                </tr>
                {{/each}}
            </tbody>
        </table>
        <div class="btn-group">
            <button class="btn-default btn js-alarm-sel-acknowledge">{{TR "Quittieren"}}</button>
        </div>
    </div>
</div>
